import { axiosInstance } from '@/lib/api';
import { ApiResponse } from '@/lib/api/types';
import { getRefreshToken } from '@/lib/utils/auth';

export interface LoginDto {
  phone: string;
  password: string;
  rememberMe?: boolean;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  user: {
    id: number;
    username: string;
    full_name?: string;
    role?: string;
    role_code?: string;
    role_name?: string;
    department_id?: number;
    department_code?: string;
    department_name?: string;
    warehouse_id?: number;
    avatar_url?: string;
    status?: string;
    is_board?: boolean;
    job_title?: string;
    permissions?: string[];
  };
}

export interface RegisterDto {
  code: string;
  phone: string;
  password: string;
  confirm_password: string;
  full_name?: string;
  role_id: number;
  registration_code: string;
}

export const authService = {
  // Login
  login: async (data: LoginDto): Promise<LoginResponse> => {
    const response = await axiosInstance.post<ApiResponse<LoginResponse>>('/auth/login', {
      phone: data.phone,
      password: data.password,
    });
    return response.data.data;
  },

  // Register
  register: async (data: RegisterDto): Promise<LoginResponse> => {
    const response = await axiosInstance.post<ApiResponse<LoginResponse>>('/auth/register', {
      code: data.code,
      phone: data.phone,
      password: data.password,
      confirm_password: data.confirm_password,
      full_name: data.full_name,
      role_id: data.role_id,
      registration_code: data.registration_code,
    });
    return response.data.data;
  },

  // Logout
  logout: async (): Promise<void> => {
    const refreshToken = getRefreshToken();
    await axiosInstance.post<ApiResponse<{ ok: boolean }>>('/auth/logout', {
      refresh_token: refreshToken,
    });
  },

  // Refresh token
  refreshToken: async (refreshToken: string): Promise<LoginResponse> => {
    const response = await axiosInstance.post<ApiResponse<LoginResponse>>('/auth/refresh-token', {
      refresh_token: refreshToken,
    });
    return response.data.data;
  },

  // Get current user - sử dụng endpoint /me
  getCurrentUser: async (): Promise<LoginResponse['user']> => {
    const response = await axiosInstance.get<ApiResponse<LoginResponse['user']>>('/me');
    return response.data.data;
  },

  // Quên mật khẩu - gửi OTP qua Zalo
  requestPasswordResetOtp: async (phone: string): Promise<{ ok: boolean }> => {
    const response = await axiosInstance.post<ApiResponse<{ ok: boolean }>>(
      '/auth/forgot-password/request-otp',
      { phone }
    );
    return response.data.data;
  },

  // Quên mật khẩu - xác thực OTP và đặt lại mật khẩu
  resetPassword: async (phone: string, otp: string, new_password: string): Promise<{ ok: boolean }> => {
    const response = await axiosInstance.post<ApiResponse<{ ok: boolean }>>(
      '/auth/forgot-password/reset',
      { phone, otp, new_password }
    );
    return response.data.data;
  },
};
